module.exports = __webpack_public_path__ + "static/media/bg7.b08234a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg7.jpg
// module id = 5883
// module chunks = 0